"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeOptionsDefault = void 0;
const constants_1 = require("./constants");
exports.storeOptionsDefault = {
    storage: constants_1.StorageLocation.Local,
    prefix: 'mb',
    debug: false,
};
//# sourceMappingURL=options.js.map